import { Divider, Cell, Text, Label, Image } from '@vinted/web-ui';
import SeparatedList from 'components/SeparatedList';
import useTranslate from 'hooks/useTranslate';
import useTracking from 'hooks/useTracking';
import { CatalogAttribute } from 'constants/catalog';
import { selectCatalogEvent } from 'libs/common/event-tracker/events';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const CategoriesSection = _ref => {
  let {
    categories
  } = _ref;
  const translate = useTranslate('header.side_bar');
  const {
    track
  } = useTracking();

  const handleTitleClick = _ref2 => {
    let {
      id
    } = _ref2;
    return () => {
      const trakingEvent = selectCatalogEvent({
        catalogIds: [id],
        attributeId: CatalogAttribute.Navigation
      });
      track(trakingEvent);
    };
  };

  const renderCategoriesItem = item => {
    var _item$photo;

    return /*#__PURE__*/_jsx(Cell, {
      type: Cell.Type.Navigating,
      prefix: /*#__PURE__*/_jsx(Image, {
        src: (_item$photo = item.photo) === null || _item$photo === void 0 ? void 0 : _item$photo.url,
        scaling: Image.Scaling.Cover,
        size: Image.Size.Regular
      }),
      body: /*#__PURE__*/_jsx(Text, {
        truncate: true,
        children: item.title
      }),
      url: item.url,
      urlProps: {
        title: item.title
      },
      onClick: handleTitleClick(item),
      testId: "sidebar-category-item-".concat(item.id),
      aria: {
        'aria-label': item.title
      }
    }, item.id);
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Label, {
      styling: Label.Styling.Wide,
      text: translate('categories')
    }), /*#__PURE__*/_jsx(SeparatedList, {
      separator: /*#__PURE__*/_jsx(Divider, {}),
      children: categories.map(renderCategoriesItem)
    })]
  });
};

export default CategoriesSection;